import React, { Component } from "react";
import { Form, Input, Button, Checkbox, Icon, notification, Tooltip } from "antd";
import { Link, Redirect } from "react-router-dom";
import axios from "axios";
import Header from "../../User/Header";
import { GlobalContext } from "../../app/providers/GlobalState";

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description,
        iconLoading: false
    });
};

class RegistarConta extends Component {
    static contextType = GlobalContext;
    state = {
        nome: "",
        email: "",
        //LOADING
        iconLoading: false,
        //REDIRECT
        redirect: false,
        redirectLink: ""
    };

    handleChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    criar = () => {
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.setState({ iconLoading: true });

                var item = new FormData();
                item.append("entidadeId", localStorage.getItem("entidadeId"));
                item.append("entidadeUrl", this.props.match.params.entidade);
                item.append("nome", this.state.nome);
                item.append("email", this.state.email);

                axios({
                    method: "post",
                    url: "/api/pagina-entidade/registar-conta",
                    data: item
                })
                    .then(() => {
                        openNotificationWithIcon(
                            "success",
                            "Sucesso",
                            "Nova conta registada! Confirme o seu email para poder utilizar a plataforma."
                        );
                        this.setState({
                            redirect: true,
                            redirectLink: `/${this.props.match.params.entidade}/login`
                        });
                    })
                    .catch(error => {
                        openNotificationWithIcon("error", "Erro", error.response.data);
                        this.setState({
                            iconLoading: false
                        });
                    });
            }
        });
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        const {
            nome,
            email,
            //LOADING
            iconLoading,
            //REDIRECT
            redirect,
            redirectLink
        } = this.state;

        if (redirect) return <Redirect to={redirectLink} />;

        return (
            <>
                <Header titulo="Criar conta" marginTop0={true} />
                <div className="content">
                    <Form onSubmit={this.handleSubmit} className="login template-form">
                        <Form.Item label="Nome">
                            {getFieldDecorator("nome", {
                                rules: [
                                    {
                                        required: true,
                                        message: "Campo obrigatório"
                                    }
                                ],
                                initialValue: nome
                            })(<Input name="nome" onChange={this.handleChange} />)}
                        </Form.Item>
                        <Form.Item label="E-mail">
                            {getFieldDecorator("email", {
                                rules: [
                                    {
                                        required: true,
                                        message: "Campo obrigatório"
                                    }
                                ],
                                initialValue: email
                            })(<Input name="email" onChange={this.handleChange} />)}
                        </Form.Item>
                        <Form.Item style={{ marginBottom: 0 }}>
                            <Button type="primary" className="login-form-button form-button" disabled={iconLoading} onClick={this.criar}>
                                {iconLoading ? <Icon type="loading" /> : null}
                                Registar
                            </Button>
                            <div className="bloco-login-links">
                                <Link to={`/${this.props.match.params.entidade}/login`} className="form-link">
                                    Voltar <i className="fas fa-chevron-right"></i>
                                </Link>
                            </div>
                        </Form.Item>
                    </Form>
                </div>
            </>
        );
    }
}

const FormRegistarConta = Form.create({ name: "form-registar-conta" })(RegistarConta);

export default FormRegistarConta;
